import { render, staticRenderFns } from "./IconPencilSolid.vue?vue&type=template&id=c66c4a80"
import script from "./IconPencilSolid.vue?vue&type=script&lang=js"
export * from "./IconPencilSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports